import { REACT_FRONTEND_ENABLED } from 'src/config/releaseFeatures'
import {
  symRoundedAnalytics,
  symRoundedAttachMoney,
  symRoundedAutoAwesomeMosaic,
  symRoundedChecklist,
  symRoundedDownload,
  symRoundedFactCheck,
  symRoundedFinance,
  symRoundedJoinInner,
  symRoundedPayments,
  symRoundedReceiptLong,
  symRoundedShoppingCart,
  symRoundedRequestQuote,
} from '@quasar/extras/material-symbols-rounded'

export const IMPERIAL_COMPANY_ID = 'c0655502-753f-4ebf-a3ac-1272aa68f08c'

export interface CustomMenuItem {
  id: string
  label: string
  type: 'link' | 'download' | 'menu'
  icon?: string
  to?: string
  downloadUrl?: string
  filename?: string
  category: string
  childs?: CustomMenuItem[]
  order?: number
  roles?: string[]
  permissions?: string[]
  companyIds?: string[]
}

export const customMenuItems: CustomMenuItem[] = [
  {
    id: 'custom:parts-orders',
    label: 'parts_orders',
    type: 'link',
    icon: symRoundedShoppingCart,
    to: '/parts-to-order',
    category: 'administration',
    permissions: ['transactions.review', 'parts-orders.create'],
  },
  {
    id: 'custom:ai-document-processor',
    label: 'ai_document_processor',
    type: 'link',
    icon: symRoundedAutoAwesomeMosaic,
    to: '/ai-document-processor',
    category: 'administration',
    roles: ['developer'],
  },
  {
    id: 'custom:finances',
    label: 'finances',
    type: 'link',
    icon: symRoundedFinance,
    to: REACT_FRONTEND_ENABLED ? '/react/dashboard/finances' : '/dashboard/finances',
    category: 'accounting',
    permissions: ['see.reports.financial'],
  },
  {
    id: 'custom:payments',
    label: 'payments',
    type: 'link',
    icon: symRoundedPayments,
    to: '/payments',
    category: 'accounting',
    roles: ['admin', 'developer'],
  },
  {
    id: 'custom:credit-notes',
    label: 'credit_notes',
    type: 'link',
    icon: symRoundedReceiptLong,
    to: '/credit-notes',
    category: 'accounting',
    roles: ['admin', 'manager', 'developer'],
  },
  {
    id: 'custom:compliance-registers',
    label: 'compliance_registers',
    type: 'link',
    icon: symRoundedFactCheck,
    to: '/compliance-registers',
    category: 'operations',
    permissions: ['cm-business_partner_read'],
  },
  {
    id: 'custom:compliance-register-template',
    label: 'compliance_register_template',
    type: 'link',
    icon: symRoundedChecklist,
    to: '/compliance-registers/template',
    category: 'administration',
    permissions: ['view_admin_panel'],
  },
  {
    id: 'custom:partner-dedup',
    label: 'partner_dedup',
    type: 'link',
    icon: symRoundedJoinInner,
    to: '/admin/business-partners/dedup',
    category: 'administration',
    permissions: ['manage.business-partners.merge'],
  },
  {
    id: 'custom:reports',
    label: 'reports',
    type: 'menu',
    icon: symRoundedAnalytics,
    category: 'administration',
    childs: [
      {
        id: 'custom:monthly-sales',
        label: 'monthly_sales',
        type: 'download',
        icon: symRoundedDownload,
        downloadUrl: '/sales-report/pdf',
        filename: 'rapport-mensuel.pdf',
        category: 'administration',
        permissions: ['see.reports.financial'],
      },
      {
        id: 'custom:ar-aging',
        label: 'ar_aging',
        type: 'download',
        icon: symRoundedDownload,
        downloadUrl: '/ar/reports/aging-summary',
        filename: 'recapitulatif_comptes_recevables.pdf',
        category: 'administration',
        permissions: ['see.reports.financial', 'ar.view'],
      },
      {
        id: 'custom:tag-commission-christian-bergeron',
        label: 'tag_commission',
        type: 'link',
        icon: symRoundedRequestQuote,
        to: '/dashboard/reports/tag-commission',
        category: 'administration',
        permissions: ['see.reports.financial'],
      },
      {
        id: 'custom:inventory-problems',
        label: 'inventory_problems',
        type: 'download',
        icon: symRoundedDownload,
        downloadUrl: '/reporting/parts/inventory-problems',
        filename: 'Problemes_inventaire.pdf',
        category: 'administration',
        permissions: ['see.reports.inventory'],
      },
      {
        id: 'custom:imperial-price-list',
        label: 'imperial_price_list',
        type: 'download',
        icon: symRoundedAttachMoney,
        downloadUrl: '/reporting/parts/imperial-price-list',
        filename: 'Liste_prix_Imperial.xlsx',
        category: 'administration',
        permissions: ['see.reports.inventory'],
        companyIds: [IMPERIAL_COMPANY_ID],
      },
    ],
  },
]
